class ListHelper {
    public static getNameFormat(text: string): string {
        return text ? `${text.charAt(0).toUpperCase()}${text.slice(1)}` : "";
    }
}

export { ListHelper };
